import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { VolumeWithId } from '@innersight-os/shared/firestore-interfaces';

import { ModelType, MODEL_CONFIGS } from '@innersight-os/shared/util-model-config';
import { ThumbnailService } from '../../services/storage/thumbnail.service';

@Component({
    selector: 'is-thumbnail',
    templateUrl: './thumbnail.component.html',
    styleUrls: ['./thumbnail.component.scss'],
    standalone: false
})
export class ThumbnailComponent implements OnInit, OnDestroy {
  @Input() modelType: ModelType
  @Input() volume: VolumeWithId

  url: string

  constructor(
    private thumbnails: ThumbnailService,
  ) {}

  async ngOnInit() {
    if (this.volume.convert?.success) {
      const response = await this.thumbnails.requestThumbnail({
        operationId: this.volume.operationId,
        uploadId: this.volume.uploadId,
        volumeId: this.volume.id,
        contrastWindow: this.volume.contrastWindow ?? [...MODEL_CONFIGS[this.modelType].defaultIntensityRange]
      })

      if(response.status !== 200) {
        this.url = 'ThumbnailComponentError'
      } else {
        this.url = response.url
      }
    }
  }

  ngOnDestroy() {
    URL.revokeObjectURL(this.url)
  }

  hasThumbnail(): boolean {
    const {convert, shape} = this.volume
    return convert?.success && Math.min(shape[0], shape[1]) >= 16 // Cloud Run thumbnailer fails if shape[0,1]<16
  }

  get dims(): [number, number] {
    const [shapeX, shapeY] = this.volume.shape
    const [spacingX, spacingY] = this.volume.spacing
    const [width, height] = [shapeX * spacingX, shapeY * spacingY]
    const length = Math.max(width, height) / 200
    return [width / length, height / length]
  }
}
